"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const Vector_js_1 = __importDefault(require("ol/source/Vector.js"));
const format_1 = require("ol/format");
const downloadFile_1 = __importDefault(require("@common/tsutils/downloadFile"));
const html2canvas_1 = __importDefault(require("html2canvas"));
class ExportBuilder {
    constructor(map = new Map()) {
        this.map = map;
    }
    get features() {
        const layers = this.map.getLayers();
        const sources = layers.getArray().map(layer => layer.getSource());
        const features = sources.filter(source => source instanceof Vector_js_1.default).map(source => source.getFeatures());
        return features.flat();
    }
    export(filename, format) {
        switch (format) {
            case 'kml':
                return this.exportKml(filename);
            case 'png':
            case 'jpg':
                return this.exportImage(filename, format);
            default:
                console.log('the format selected can not be exported!');
        }
    }
    exportKml(filename) {
        const type = 'application/vnd.google-earth.kml+xml';
        const extention = 'kml';
        const format = new format_1.KML();
        const content = format.writeFeatures(this.features, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857',
        });
        this.download(filename, extention, type, content);
    }
    exportImage(filename, extention) {
        const element = this.map.getTargetElement();
        if (element) {
            (0, html2canvas_1.default)(element).then((canvas) => {
                const image = canvas.toDataURL(`image/${extention}`);
                const link = document.createElement('a');
                link.href = image;
                link.download = `${filename}.${extention}`;
                link.click();
            });
        }
    }
    download(filename, extention, type, content) {
        const blob = new Blob([content], { type: type });
        (0, downloadFile_1.default)(blob, filename + '.' + extention, 'application/vnd.google-earth.kml+xml');
    }
}
exports.default = ExportBuilder;
